var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopRestaurants = function SvgTopRestaurants(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m1.5 4.875 1.5 8.25m-1.5 6 1.5-6h3a1.5 1.5 0 0 1 1.5 1.5v4.5m15-14.25-1.5 8.25m1.5 6-1.5-6h-3a1.5 1.5 0 0 0-1.5 1.5v4.5M12 8.625v10.5m-5.25-10.5h10.5"
  })));
};
export { SvgTopRestaurants as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTEuNSA0Ljg3NSAxLjUgOC4yNU0xLjUgMTkuMTI1bDEuNS02aDNhMS41IDEuNSAwIDAgMSAxLjUgMS41djQuNU0yMi41IDQuODc1bC0xLjUgOC4yNU0yMi41IDE5LjEyNWwtMS41LTZoLTNhMS41MDAxIDEuNTAwMSAwIDAgMC0xLjUgMS41djQuNU0xMiA4LjYyNXYxMC41TTYuNzUgOC42MjVoMTAuNSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+Cg==";